const NORMAL_SIGN_OUT_KEYS = [
  'yan_nda_accepted',
  'yan_nda_accepted_sponsors',
] as const

const FULL_SIGN_OUT_KEYS = [
  'yan_email',
  'yan_machine_known',
  'yan_tc_accepted',
  'yan_vada_auth_cooldown_until',
  ...NORMAL_SIGN_OUT_KEYS,
] as const

interface ClearBrowserStateOptions {
  full?: boolean
}

export function safeNextPath(next = '/') {
  return next.startsWith('/') && !next.startsWith('//') ? next : '/'
}

export async function clearYanVadaBrowserState(options: ClearBrowserStateOptions = {}) {
  const keys = options.full ? FULL_SIGN_OUT_KEYS : NORMAL_SIGN_OUT_KEYS
  try {
    for (const key of keys) localStorage.removeItem(key)
    if (options.full) sessionStorage.clear()
  } catch {
    /* noop */
  }

  if (!options.full || !('caches' in window)) return
  try {
    const cacheNames = await caches.keys()
    await Promise.all(cacheNames.map(name => caches.delete(name)))
  } catch {
    /* noop */
  }

  if (!('serviceWorker' in navigator)) return
  try {
    const registrations = await navigator.serviceWorker.getRegistrations()
    await Promise.all(registrations.map(registration => registration.unregister()))
  } catch {
    /* noop */
  }
}

export function isLocalPreviewHost(hostname = window.location.hostname) {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1'
}

export function fullSignOutUrl(next = '/') {
  const safeNext = safeNextPath(next)
  return `/api/auth/full-signout?next=${encodeURIComponent(safeNext)}`
}

export async function beginFullSignOutAndRestart(next = '/') {
  const safeNext = safeNextPath(next)
  await clearYanVadaBrowserState({ full: true })
  if (isLocalPreviewHost()) {
    window.location.replace(`/signin?next=${encodeURIComponent(safeNext)}&fresh=1`)
    return
  }
  window.location.replace(fullSignOutUrl(safeNext))
}
